import SearchResultItem from "./SearchResultItem";
import "./SearchResultsList.scss";

const SearchResultsList = ({ searchTerm, searchResults }) => {

	return (
		<div className="searchResultsList" data-test-id="search-results-list">
			<SearchResultItem searchResults={searchResults} searchTerm={searchTerm}></SearchResultItem>
		</div>
	);
};

export default SearchResultsList;
